var map = {
	"./all.svg": "111f",
	"./email.svg": "caf7",
	"./global.svg": "220c",
	"./gps.svg": "9c29",
	"./guidao.svg": "9c3f",
	"./honor.svg": "db28",
	"./info.svg": "b888",
	"./jigsaw.svg": "92e9",
	"./logo.svg": "d9b6",
	"./more.svg": "d5d3",
	"./phone.svg": "b470",
	"./ring.svg": "2229",
	"./shoudiangong.svg": "ecab",
	"./suggestion.svg": "41e4",
	"./suidao.svg": "0674",
	"./top.svg": "e10f",
	"./train.svg": "1372",
	"./user.svg": "d88a",
	"./weChat.svg": "494a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";